angular.module('unergie.main')
.controller('contractConsentsModalCtrl', ($scope, $timeout, $uibModalInstance, DataAccess, DraftsBasic, AlertManager, ErrorCatcher, contract, draft) => {
    $scope.fetching = true
    let id_draft_basic = null

    const activate = () => {
        return Promise.resolve()
        .then(() => {
            if (contract) {
                return DataAccess.getContractConsents({ id_contract: contract.id, step: 'RESUME' }).$promise
            }
            return DraftsBasic.getDraftBasicIdForDraftElec({ id: draft.id }).$promise
            .then((result) => {
                id_draft_basic = result.id_draft_basic
                return DataAccess.getDraftConsents({ id_draft_basic: result.id_draft_basic, step: 'SUBSCRIPTION' }).$promise
            })
        })
        .then((consents) => {
            $scope.consents = consents
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $timeout(() => {
                $scope.fetching = false
            })
        })
    }

    activate()

    $scope.close = $uibModalInstance.dismiss
    $scope.ok = () => {
        $scope.updating = true
        const payload = _.keyBy($scope.consents, 'id')
        _.each(payload, (value, key) => {
            payload[key] = value.value
        })
        return Promise.resolve()
        .then(() => {
            if (contract) {
                return DataAccess.updateConsents({ id_account: contract.id_account, id_contract: contract.id }, payload).$promise
            }
            return DataAccess.updateDraftConsents({ id_draft_basic }, payload).$promise
        })
        .then(() => {
            AlertManager.success('Consentements mis à jour')
            $uibModalInstance.close()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.updating = false
        })
    }
})
